import React, { Component } from 'react'
import Form from '../Form/Form'

class Login extends Component {

    state = {
        username: '',
        password: ''
    }

    onSubmit = () => {
        this.props.onChange(this.state.username.trim() + ":" + this.state.password.trim())
    }

    render() {

        return (
            <div className="Synonyms">
                <h2>Login</h2>
            	<Form onSubmit={this.onSubmit}>
                <input
                    type="text"
                    placeholder="Username"
                    value={this.state.username}
                    onChange={e => this.setState({ username: e.target.value })}
                />
                <p/>
                <input
                    type="password"
                    placeholder="Password"
                    value={this.state.password}
                    onChange={e => this.setState({ password: e.target.value })}
                />
                <p/>
                <div>
                    <button>Sign in</button>
                </div>
	            </Form>
            </div>
        )
    }
    /*
    <textarea
        spellCheck="false"
        value={synonyms}
        onChange={e => this.setState({ synonyms: e.target.value })}>
    </textarea>
    */
}

export default Login



// WEBPACK FOOTER //
// ./src/components/Login/Login.js